// extracted by mini-css-extract-plugin
module.exports = {"multiLine":"_3BAHlo5-X3nky1hZJQBG0n"};